import styled from 'styled-components';

export const Wrapper = styled.div`
  height: 100%;
  width: 100%;
  background: linear-gradient(-90deg, #f0f0f5, #e6ffff);
  display: flex;
  justify-content: center;
  align-items: center;
`;
